/**
 * Custom hook for SEO data management
 */
import { useState, useEffect } from 'react';
import { getSEOData, getSEODataByPath } from '../utils/seo';

export const useSEO = (pageSlug = null) => {
  const [currentPath, setCurrentPath] = useState('/');
  const [seoData, setSeoData] = useState({
    metaTitle: 'Baashyaam Group - Luxury Apartments in Chennai',
    metaDescription: 'Discover luxury living in Chennai with Baashyaam Group. Premium residential and commercial projects with innovative architecture and unmatched lifestyle experience.',
    url: 'https://www.bashyamgroup.com/',
    canonical: 'https://bashyamgroup.com/'
  });
  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const updatePath = () => {
        const newPath = window.location.pathname;
        setCurrentPath(newPath);
        // console.log('Path changed to:', newPath);
      };
      
      // Initial update
      updatePath();
      
      // Listen for route changes
      window.addEventListener('popstate', updatePath);
      
      // Listen for pushstate/replacestate (for programmatic navigation)
      const originalPushState = window.history.pushState;
      const originalReplaceState = window.history.replaceState;
      
      window.history.pushState = function(...args) {
        originalPushState.apply(window.history, args);
        setTimeout(updatePath, 0);
      };
      
      window.history.replaceState = function(...args) {
        originalReplaceState.apply(window.history, args);
        setTimeout(updatePath, 0);
      };
      
      return () => {
        window.removeEventListener('popstate', updatePath);
        window.history.pushState = originalPushState;
        window.history.replaceState = originalReplaceState;
      };
    }
  }, []);
  
  useEffect(() => {
    if (pageSlug) {
      // Use provided page slug
      const data = getSEOData(pageSlug);
      setSeoData(data);
      // console.log('Using provided slug:', pageSlug, data);
    } else {
      // Use path-based lookup
      const data = getSEODataByPath(currentPath);
      setSeoData(data);
      // console.log('Using path-based lookup:', currentPath, data);
    }
  }, [pageSlug, currentPath]);
  
  return seoData;
};
